export const paymentMethodType = [
  'CreditCard',
  'Fpx',
  'IdVirtualAccount',
  'IdOnlineBanking',
  'IdEWallet',
  'PhOnlineBanking',
  'PhEWallet',
  'ThOnlineBanking',
  'PayNowQR',
  'Cheque',
  'Invoice',
  'IdQr',
  'PromptPay',
  'HkEWallet',
  'PayPal',
  'HkFps',
  'PhBnpl',
] as const;

export type PaymentMethodType = (typeof paymentMethodType)[number];

export type PaymentMethodType2c2p = 'WEBPAY' | 'DPAY' | 'QR';

export type Environment = 'dev' | 'staging' | 'production';

export type EwalletType =
  | 'DANA'
  | 'LINKAJA'
  | 'OVO'
  | 'GRAB'
  | 'PAYMAYA'
  | 'GCASH'
  | 'ALIPAYHK';

export type BnplType = 'BILLEASE' | 'HOMECREDIT';

export type UseCase = 'CAJA' | 'INVOICE' | 'GENERIC' | 'UPGRADE' | 'ADBUDGET';

export type StripeBetaKey = 'id_bank_transfer_beta_1';

export const virtualAccountBankAbbr = [
  'bca',
  'mandiri',
  'bni',
  'other',
] as const;

export type VirtualAccountBankAbbr = (typeof virtualAccountBankAbbr)[number];

export const PaymentIntentErrorCode = {
  paymentIntentExpired: 'payment_intent_payment_attempt_expired',
};
